import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "td__use-yn" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["title"];
const _hoisted_6 = ["title"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["title"];
const _hoisted_9 = ["title"];
const _hoisted_10 = {
    key: 0,
    class: "td__permission text-center"
};
import { computed, toRefs, } from 'vue';
import { userPermission } from '@/constants';
import { makeItemToComputed } from '@/utils/vueUtils';
import { pageTypeList } from '@/constants/userManagement/pageTypeList';
import { userStatusOptionList } from '@/constants/userManagement';
import { useRouter } from 'vue-router';
import brgI18n from '@/locales';
import { getRealTimePermission } from '@/lib/real-time-permission';
import { permissionSettingRequiredLevelList } from '@/constants/userPermissionSetting/permissionSettingRequiredLevelList';
import { routeName } from '@/constants/routeName';
import vuexStore from '@/vuex-store';
const lc = 'views.user_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        user: { default: () => { } },
        isSelected: { type: Boolean, default: true }
    },
    setup(__props) {
        const locale = {
            permissionSetting: brgI18n.global.t(`${lc}permission_setting`),
        };
        const props = __props;
        const { user, } = toRefs(props);
        const router = useRouter();
        const getterPageSizeType = computed(() => vuexStore.getters['userManagement/userList/getterPageSizeType']);
        const getterUserStatusType = computed(() => vuexStore.getters['userManagement/userList/getterUserStatusType']);
        const getterSearchField = computed(() => vuexStore.getters['userManagement/userList/getterSearchField']);
        const getterSearchValue = computed(() => vuexStore.getters['userManagement/userList/getterSearchValue']);
        const getterUserLevel = computed(() => vuexStore.getters['userManagement/userList/getterUserLevel']);
        const statusImgPath = computed({
            get() {
                const [userStatusTypeCode,] = userStatusOptionList
                    .filter((option) => option.value === user.value.useYn);
                return `/svg/use-yn-${userStatusTypeCode.imgIcon}.svg`;
            },
            set() { },
        });
        const validatedUserId = makeItemToComputed(user, 'validatedUserId');
        const validatedHubName = makeItemToComputed(user, 'validatedHubName');
        const formattedUserLevel = makeItemToComputed(user, 'formattedLevel');
        const validatedName = makeItemToComputed(user, 'validatedName');
        const formattedAdminPhoneNumber = makeItemToComputed(user, 'formattedTelephone');
        const formattedCreatedAt = makeItemToComputed(user, 'formattedCreatedAt');
        const formattedResignationAt = makeItemToComputed(user, 'formattedResignationAt');
        const validatedMemo = makeItemToComputed(user, 'validatedMemo');
        const handleClickUserId = (userId) => {
            // filter 조건 저장하기
            router.push({
                name: routeName.USER_MANAGEMENT_PAGE,
                params: {
                    pageType: pageTypeList.DETAIL.value,
                    userId,
                },
                query: {
                    searchField: getterSearchField.value,
                    searchValue: getterSearchValue.value,
                    userStatusType: getterUserStatusType.value,
                    pageSizeType: getterPageSizeType.value,
                    userLevel: getterUserLevel.value,
                },
            }).catch(() => { });
        };
        /** 권한 설정 권한 - 권한 없으면 권한 컬럼 td 미노출 */
        const getterIsPermissionSettingPermitted = computed(() => vuexStore.getters['userManagement/userList/getterIsPermissionSettingPermitted']);
        /**
         * 권한 설정 버튼 핸들러
         * 실시간 권한 체크 후 다이얼로그를 오픈한다.
         */
        const handleClickPermissionSettingBtn = async () => {
            const isPermitted = await getRealTimePermission([
                userPermission.P_UPDATE_USER_PERMISSION,
            ], permissionSettingRequiredLevelList);
            if (!isPermitted) {
                return;
            }
            vuexStore.dispatch('userPermissionSettingDialog/setDialogDetail', user.value);
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("img", { src: statusImgPath.value }, null, 8 /* PROPS */, _hoisted_2)
                ]),
                _createElementVNode("td", {
                    class: "td__user-id",
                    onClick: _cache[0] || (_cache[0] = ($event) => (handleClickUserId(_unref(user).userId)))
                }, _toDisplayString(_unref(validatedUserId)), 1 /* TEXT */),
                _createElementVNode("td", {
                    class: "td__hub-name",
                    title: _unref(validatedHubName)
                }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(validatedHubName)), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_3),
                _createElementVNode("td", {
                    class: "td__user-level",
                    title: _unref(formattedUserLevel)
                }, _toDisplayString(_unref(formattedUserLevel)), 9 /* TEXT, PROPS */, _hoisted_4),
                _createElementVNode("td", {
                    class: "td__user-name",
                    title: _unref(validatedName)
                }, _toDisplayString(_unref(validatedName)), 9 /* TEXT, PROPS */, _hoisted_5),
                _createElementVNode("td", {
                    class: "td__admin-phone-number",
                    title: _unref(formattedAdminPhoneNumber)
                }, _toDisplayString(_unref(formattedAdminPhoneNumber)), 9 /* TEXT, PROPS */, _hoisted_6),
                _createElementVNode("td", {
                    class: "td__created-date",
                    title: _unref(formattedCreatedAt)
                }, _toDisplayString(_unref(formattedCreatedAt)), 9 /* TEXT, PROPS */, _hoisted_7),
                _createElementVNode("td", {
                    class: "td__resignation_at",
                    title: _unref(formattedResignationAt)
                }, _toDisplayString(_unref(formattedResignationAt)), 9 /* TEXT, PROPS */, _hoisted_8),
                _createElementVNode("td", {
                    class: "td__user-memo",
                    title: _unref(validatedMemo)
                }, _toDisplayString(_unref(validatedMemo)), 9 /* TEXT, PROPS */, _hoisted_9),
                (getterIsPermissionSettingPermitted.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                        _createVNode(_component_v_btn, {
                            class: "brg-btn info outlined size-xs",
                            onClick: handleClickPermissionSettingBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                    small: "",
                                    class: "pr-1"
                                }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-lock-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(locale.permissionSetting), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1 /* CACHED */))
            ]));
        };
    }
});
